import React from 'react';
import { Button, Dropdown, Tabs } from 'antd';
import type { MenuProps } from 'antd';
import { MoreOutlined } from '@ant-design/icons';
import type { NavTabItem } from '../config/navTabs';

type NavTabAction = 'refresh' | 'close-current' | 'close-others' | 'close-left' | 'close-right' | 'close-all';

interface NavTabsProps {
  activeKey: string;
  tabs: NavTabItem[];
  onChange: (path: string) => void;
  onClose: (path: string) => void;
  onAction: (action: NavTabAction) => void;
}

const NavTabs: React.FC<NavTabsProps> = ({ activeKey, tabs, onChange, onClose, onAction }) => {
  const actionItems: MenuProps['items'] = [
    { key: 'refresh', label: '刷新当前' },
    { type: 'divider' },
    { key: 'close-current', label: '关闭当前' },
    { key: 'close-others', label: '关闭其他' },
    { key: 'close-left', label: '关闭左侧' },
    { key: 'close-right', label: '关闭右侧' },
    { type: 'divider' },
    { key: 'close-all', label: '关闭全部' },
  ];

  return (
    <div className="nav-tabs-bar">
      <Tabs
        type="editable-card"
        size="small"
        hideAdd
        activeKey={activeKey}
        items={tabs.map((tab) => ({
          key: tab.key,
          label: tab.title,
          closable: tab.closable,
        }))}
        onChange={onChange}
        onEdit={(targetKey, action) => {
          if (action === 'remove') {
            onClose(String(targetKey));
          }
        }}
        tabBarExtraContent={
          <Dropdown
            menu={{
              items: actionItems,
              onClick: ({ key }) => onAction(key as NavTabAction),
            }}
            placement="bottomRight"
          >
            <Button type="text" size="small" icon={<MoreOutlined />} />
          </Dropdown>
        }
      />
    </div>
  );
};

export default NavTabs;
